<template>
  <div v-if="loaded" class="row">
    <slot name="Observations" />
    <div class="col-12">
      <ValidationProvider
        name="Documentos"
        v-slot="{ validate: _validate, errors }"
        vid="document"
        :rules="{
          required:
            !sectionsStates[enums.sections['Documentos']].readonly && validate
              ? { allowFalse: false }
              : false,
        }"
        :custom-messages="{ required: 'Favor anejar un documento.' }"
      >
        <Documents
          :key="documentLength"
          :disabled="
            readonly || sectionsStates[enums.sections['Documentos']].readonly
          "
          :documents="getDocumentData"
          :document-types="document.documentTypes"
          :center-title-header="'Documentos'"
          @input="_validate(document.data && !![...document.data.files].length)"
          @files="
            gettingDocument($event);
            _validate(document.data && !![...document.data.files].length);
          "
        />

        <Error v-if="errors[0]" variant="no-border" :message="errors[0]" />
      </ValidationProvider>
    </div>

    <div
      v-if="showServicesSummary && servicesSummary.length > 0"
      class="col-12"
    >
      <ServicesSummary
        :services="servicesSummary"
        :collections="servicesSummaryCollections"
        :readonly="true"
        :hide-total="false"
      />
    </div>
    <div v-else-if="showServicesSummary" class="col-12">
      <b-alert show variant="info" class="mb-0">Sin servicios</b-alert>
    </div>

    <div class="my-3 col-12">
      <Requesters
        keep-signed
        :limit-new-signatures-to="1"
        :allow-add-more="false"
        :submitted="
          readonly ||
            sectionsStates[enums.sections['Funcionarios Solicitan']].readonly
        "
        :requesters="model.requesters"
        :positions-list="requestersPositionsList"
        :cannot-edit-name="true"
        :use-role="true"
        title="Firma del Secretario de Educación Especial"
        @input="runValidation(_validate)"
      />
    </div>
  </div>
</template>

<script>
import {
  Requesters,
  Documents,
} from '@/components/pei/ubication-tech-assistance/_components';
import Error from 'custom-error';
import { tapRequestTypesEnum } from '@/components/pei/ubication-tech-assistance/_types';
import {
  getSAEEAnalysis,
  getDocumentTypesByCode,
} from '@/services/api/tapRequest.api';
import { UTA_MANAGEMENT_SECTION_ENUM } from '@/components/pei/ubication-tech-assistance/_config/management';
import { statusManagementStore } from '@/components/pei/ubication-tech-assistance/_store';
import { mapActions } from 'vuex';
import ServicesSummary from '@/components/pei/ubication-tech-assistance/management/_components/CentralLevelAnalysis/components/ServicesSummary/Main.vue';

export default {
  name: 'SAEEAnalysis',
  inject: { studentSieId: { default: 0 }, tapRequestId: { default: 0 } },
  components: { Requesters, Documents, Error, ServicesSummary },
  props: {
    readonly: { type: Boolean, default: false },
    validate: { type: Boolean, default: false },
    sectionsStates: { type: Object, default: () => ({}) },
    modelToSave: { type: Object, default: () => {} },
    showServicesSummary: { type: Boolean, default: false },
    servicesSummary: { type: Array, default: () => [] },
    servicesSummaryCollections: { type: Object, default: () => ({}) },
  },
  data: () => ({
    documentLength: 0,
    enums: { sections: UTA_MANAGEMENT_SECTION_ENUM },
    loaded: false,
    tapRequestTypeId: tapRequestTypesEnum.SAEEAnalysis,
    document: {
      documentTypes: [],
      // Variables to save component data.
      data: {
        files: [],
        types: [],
      },
    },
    model: {
      studentSieId: null,
      staffMembers: [],
      inquiries: [],
      documents: [],
    },
    requestersPositionsList: [],
  }),
  computed: {
    getDocumentData() {
      return this.document.data;
    },
  },
  methods: {
    ...mapActions(statusManagementStore, ['setApprovalNotifiedInfo']),
    runValidation(validateFn) {
      if (validateFn && typeof validateFn === 'function') {
        validateFn();
      }
    },
    async getData() {
      const { data } = await getSAEEAnalysis(this.tapRequestId);
      this.model = {
        ...this.model,
        ...data,
        document: this.document,
        requesters: data.staffMembers.map((c) => {
          return {
            id: c.id,
            name: c.fullName,
            status: c.status,
            userName: c.userName,
            email: c.email,
            phone: c.telephoneNumber,
            signed: c.signed,
            role: {
              id: c.rolId,
              name: c.rol,
            },
            signDate: c.signDate,
          };
        }),
      };
      this.setApprovalNotifiedInfo({
        academicYear: null,
        determination: data.approvalDetermination,
      });

      this.setApprovalNotifiedInfo({
        academicYear: null,
        determination: data.approvalDetermination,
      });

      this.$emit('update:modelToSave', this.model);
      this.fillDocuments();
    },
    async getDocumentTypesByCode(code) {
      const { data } = await getDocumentTypesByCode(code);
      data.forEach((element) => {
        this.document.documentTypes.push({
          id: element.id,
          name: element.name,
        });
      });
    },
    async gettingDocument(data) {
      this.document.data = data;
    },
    fillDocuments() {
      this.document.data = {
        files: [],
        types: [],
      };
      if (this.model.documents && this.model.documents.length > 0) {
        this.model.documents.forEach((element) => {
          this.document.data.files.push({
            name: element.filename,
            peiStatus: element.peiStatus,
            pei: element.peiId,
            documentType: element.document.documentTypeId,
            documentTypeName: element.document.documentTypeName,
            id: element.documentId,
            inServer: true,
            isReport: element.isReport,
            readOnly: element.readOnly,
            createdDate: element.createdDate,
            userName: element.userName,
            userFullName: element.userFullName,
            isAmendmentDocument: element.isAmendmentDocument,
          });
          this.document.data.types.push(element.document.documentTypeId);
        });
      }
      this.documentLength++;
    },
  },
  async created() {
    await Promise.all([
      this.getData(),
      this.getDocumentTypesByCode('TapRequestAnalisisSaee'),
    ]);
    this.loaded = true;
  },
};
</script>
